/**
 * A versão da aplicação, num módulo só dela.
 *
 * Morava em src/index.js, o ponto de entrada — importar dali arrasta Routes,
 * antd e o app inteiro, o que quebra qualquer teste que só queira saber o
 * número. Aqui é uma constante isolada, e src/index.js reexporta para não
 * mudar quem já importava de '~/index'.
 *
 * A versão só sobe quando o Redhmam pede um vídeo de novidades — não a cada
 * mudança e não a cada deploy. O número existe para amarrar a leva ao vídeo e
 * ao aviso no sininho; subir sem anunciar nada troca o rodapé sem motivo e
 * enche o histórico de versões de uma linha só.
 *
 * Entre um vídeo e outro, o que o usuário percebe vai para PENDENTES em
 * changelog.constants.js. Ao pedir o vídeo: PENDENTES vira o `changes` da
 * versão nova, sobe o número aqui e no package.json, e PENDENTES esvazia.
 * O teste em constants/__tests__/versao.test.js falha se algo divergir.
 */
export var ApplicationVersion = 'v1.46.0';
